import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function Lesson() {
  const { slug, lessonSlug } = useParams();
  const { user } = useAuth();
  const [lesson, setLesson] = useState<any>(null);
  const [course, setCourse] = useState<any>(null);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    (async () => {
      const { data: c } = await supabase.from("courses").select("*").eq("slug", slug).maybeSingle();
      if (!c) return;
      setCourse(c);
      const { data: l } = await supabase.from("lessons").select("*").eq("course_id", c.id).eq("slug", lessonSlug).maybeSingle();
      setLesson(l);
      if (user && l) {
        const { data } = await supabase.from("lesson_progress").select("id").eq("user_id", user.id).eq("lesson_id", l.id).maybeSingle();
        setCompleted(!!data);
      }
    })();
  }, [slug, lessonSlug, user]);

  async function markDone() {
    if (!user || !lesson) return;
    const { error } = await supabase.from("lesson_progress").insert({ user_id: user.id, lesson_id: lesson.id });
    if (error && !error.message.includes("duplicate")) {
      toast.error(error.message);
      return;
    }
    await supabase.rpc("bump_streak", { p_xp: 5 });
    setCompleted(true);
    toast.success("Lesson completed! +5 XP");
  }

  if (!lesson) return <p>Loading…</p>;

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <div className="text-sm text-muted-foreground">
        <Link to={`/courses/${slug}`} className="hover:underline">← {course?.title}</Link>
      </div>
      <h1 className="text-3xl font-bold">{lesson.title}</h1>
      {lesson.video_url && (
        <div className="aspect-video">
          <iframe src={lesson.video_url} className="w-full h-full rounded-lg" allowFullScreen />
        </div>
      )}
      <article className="prose prose-sm dark:prose-invert max-w-none whitespace-pre-wrap leading-relaxed">
        {lesson.content}
      </article>
      <div className="border-t pt-4">
        {completed ? (
          <div className="flex items-center gap-2 text-green-600">
            <Check className="h-5 w-5" /> Completed
          </div>
        ) : (
          <Button onClick={markDone}>Mark as completed</Button>
        )}
      </div>
    </div>
  );
}
